/**
 * Zod schema for the internal support-ticket form (`/support`,
 * `apps/web/src/app/routes/Support.tsx`) — GitHub issue #544, "P0: Slack
 * workspace invites failing for customers — domain restriction".
 *
 * Mirrors `apps/workers/src/api/support.ts`'s `SupportTicketRow`
 * (`POST /api/v1/support`). This endpoint replaces the Slack shared-invite
 * link as the customer support channel (Robert Syfert's decision, standup
 * 2026-06-03: "We need to get rid of Slack" — the workspace's domain
 * restriction to @herohire.ai/@iii.partners blocks every customer with
 * their own email domain from joining).
 */

import { z } from 'zod';

export const createSupportTicketRequestSchema = z.object({
  subject: z.string().min(1, 'Subject is required').max(255),
  body: z.string().min(1, 'Message is required').max(10000),
});

export type CreateSupportTicketRequest = z.infer<typeof createSupportTicketRequestSchema>;

export const supportTicketSchema = z.object({
  id: z.string(),
  user_id: z.string(),
  subject: z.string(),
  body: z.string(),
  status: z.enum(['open', 'in_progress', 'resolved', 'closed']),
  created_at: z.string(),
  updated_at: z.string(),
});

export type SupportTicketDTO = z.infer<typeof supportTicketSchema>;
